import React from "react";
import { ProjectImage, ProjectCount } from "./styled";
import FallbackImage from "newui/components/FallbackImage/FallbackImage";

export const FeatureProject = ({ title, image, count, ...props }) => {
	return (
		<ProjectImage>
			{image && (
				<FallbackImage
					src={image}
					alt={`${title} project`}
				/>
			)}
			{title && <p className="bg-slate-800 p-2 rounded-md bg-opacity-60">{title}</p>}

			{count > 0 && <ProjectCount>+{count}</ProjectCount>}
		</ProjectImage>
	);
};

FeatureProject.defaultProps = {
	title: "",
	image: "",
	count: 0,
};
